/**
 * Popup Ebook : délai, exit-intent, localStorage, tags newsletter.
 */
(function () {
  var cfg = window.SoneaEbookPopupConfig;
  if (!cfg) return;

  var popup = document.getElementById('SoneaEbookPopup');
  if (!popup) return;

  var storageKey = cfg.storageKey || 'sonea_ebook_popup_dismissed_until';
  var ttlMs = (parseInt(cfg.ttlDays, 10) || 7) * 24 * 60 * 60 * 1000;
  var delayMs = parseInt(cfg.delayMs, 10) || 8000;

  function getUntil() {
    try {
      var v = localStorage.getItem(storageKey);
      return v ? parseInt(v, 10) : 0;
    } catch (e) {
      return 0;
    }
  }

  function setCooldown() {
    try {
      localStorage.setItem(storageKey, String(Date.now() + ttlMs));
    } catch (e) {}
  }

  function isCooldownActive() {
    return getUntil() > Date.now();
  }

  function openPopup() {
    if (popup.hasAttribute('hidden')) {
      popup.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    }
  }

  function closePopup(permanent) {
    popup.setAttribute('hidden', '');
    document.body.style.overflow = '';
    if (permanent) setCooldown();
  }

  function syncTags() {
    var box = document.getElementById('SoneaEbookNewsletter');
    var hidden = document.getElementById('sonea-ebook-tags');
    if (!hidden) return;
    var base = 'ebook-lead,guide-premium';
    if (box && box.checked) {
      hidden.value = base + ',newsletter';
    } else {
      hidden.value = base;
    }
  }

  var newsletterCb = document.getElementById('SoneaEbookNewsletter');
  if (newsletterCb) {
    newsletterCb.addEventListener('change', syncTags);
  }
  syncTags();

  document.querySelectorAll('[data-sonea-ebook-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      closePopup(true);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !popup.hasAttribute('hidden')) {
      closePopup(true);
    }
  });

  if (cfg.formSuccess) {
    setCooldown();
    openPopup();
    return;
  }

  if (isCooldownActive()) {
    return;
  }

  var opened = false;
  var timer;

  function cleanupListeners() {
    document.documentElement.removeEventListener('mouseleave', onDocLeave);
    if (timer) clearTimeout(timer);
  }

  function tryOpen() {
    if (opened) return;
    opened = true;
    cleanupListeners();
    openPopup();
  }

  function onDocLeave(e) {
    if (e.target === document.documentElement && e.clientY <= 0) {
      tryOpen();
    }
  }

  document.documentElement.addEventListener('mouseleave', onDocLeave);

  timer = setTimeout(tryOpen, delayMs);

  var form = document.getElementById('SoneaEbookForm');
  if (form) {
    form.addEventListener('submit', function () {
      syncTags();
    });
  }
})();
